<template>
  <div class="wrap talk">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt return">
            <p class="return-txt">배송신청하신 제품에 대해<br><span>택배사와 운송장번호</span>를<br>입력해주세요.</p>
          </section>
          <section class="return-wrap">
            <div class="con-box">
              <h2>판매신청 제품</h2>
              <div class="item row row_jsb">
                <span class="item-tit">모델명</span>
                <span class="item-con taR">{{mdlNm}}</span>
              </div>
            </div>
            <div class="con-box">
              <h2>
                배송정보
              </h2>
              <div class="scan_div">
                <button class="scan_btn" @click="handleScanCompActive">
                  {{ !isScannerVisible ?  '운송장 스캔하기' : '닫기' }}
                </button>
              </div>
              <BarcodSC ref="barcodSC" v-if="isScannerVisible" @readText="handleReadText" />
              <div class="form-wrap" v-if="this.isEditable === true ">
                <dl class="row row_jsb row_ac">
                  <dt>택배사</dt>
                  <dd>
                    <select @change="onChange($event)" name="s_courier" id="s_courier" class="t-select" v-model="decoDirectNm">
                      <option value="">택배사를 선택해 주세요</option>
                      <option value="우체국택배">우체국택배</option>
                      <option value="CJ대한통운">CJ대한통운</option>
                      <option value="로젠택배">로젠택배</option>
                      <option value="롯데택배">롯데택배</option>
                      <option value="일양택배">일양택배</option>
                      <option value="한진택배">한진택배</option>
                      <option value="경동택배">경동택배</option>
                      <option value="CU 편의점택배">CU 편의점택배</option>
                      <option value="GS Postbox 택배">GS25 편의점택배</option>
                      <option value="direct">직접입력</option>
                    </select>
                    <!-- <dxSelectCodeList cmnsCdGrpId="USER_TYPE_CD" allYn="Y" v-model="decoDirectNm"></dxSelectCodeList> -->
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac"  v-if="this.decoDirectNm === 'direct' " >
                  <dt>택배사명</dt>
                  <dd><input type="text" id="d_courier"  v-model="purchaseModel.rcvDecoNm" class="t-input" placeholder="택배사명"></dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>운송장번호</dt>
                  <dd><input onKeyup="this.value=this.value.replace(/[^0-9]/g,'');" id="invoice_number_customer" slot="" v-model="purchaseModel.rcvWyblNum" ref="" type="text"  class="t-input" placeholder="-없이 숫자만기재" pattern="[0-9]*"></dd>
                </dl>
              </div>
              <div class="form-wrap" v-else>

                <div class="item row row_jsb">
                  <span class="item-tit">택배사명</span>
                  <span class="item-con taR">{{this.purchaseModel.rcvDecoNm}}</span>
                </div>

                <div class="item row row_jsb">
                  <span class="item-tit">운송장번호</span>
                  <span class="item-con taR">{{this.purchaseModel.rcvWyblNum}}</span>
                </div>

              </div>
            </div>
          </section>
          <div class="btn-wrap" v-if="this.isEditable === true ">
            <a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="saveWybl()">등록하기</a>
          </div>
        </article>
      </main>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'
import BarcodSC from '@/components/BarcodSC.vue'

const $ = window.$

function isNotEmpty (value) {
  return value !== undefined && value !== null && value !== ''
}

export default {
  name: 'InvoiceMgmt',
  components: {
    BarcodSC
  },
  data: () => ({

    AppConfig: AppConfig,
    mdlNm: '',
    purchaseModel: [],
    decoDirectNm: '',
    isEditable: true,
    isScannerVisible: false
  }),

  watch: {
    isScannerVisible (newVal, oldVal) {
      if (!newVal && newVal !== oldVal) {
        this.$refs.barcodSC.stopScanner()
      }
    }
  },
  computed: {

  },
  mounted () {
    this.ordNum = this.$route.query.ordNum ? this.$route.query.ordNum : this.$route.query.ord_number

    this.getPrchInfo()
  },
  methods: {

    // 송장번호 자릿수 체크
    invoiceNumberChk (txt, len) {
      console.log('====> 택배사 : ', txt)
      console.log('====> 운송장 길이 : ', len)

      var result_txt = 'true'

      if (txt.match('우체국') || txt.match('대신')) {
        if (len != 13) {
          result_txt = '숫자 13자리를 입력해주세요'
        }
      } else if (txt.match('CJ대한통운') || txt.match('한진') || txt.match('CU 편의점택배') || txt.match('GS Postbox 택배')) {
        if (!(len == 10 || len == 12)) {
          result_txt = '숫자 10자리 또는 12자리를 입력해주세요'
        }
      } else if (txt.match('로젠') || txt.match('천일')) {
        if (len != 11) {
          result_txt = '숫자 11자리를 입력해주세요'
        }
      } else if (txt.match('롯데') || txt.match(new RegExp('fedex', 'i')) || txt.match('농협')) {
        if (len != 12) {
          result_txt = '숫자 12자리를 입력해주세요'
        }
      } else if (txt.match('일양')) {
        if (!(len >= 9 && len <= 11)) {
          result_txt = '숫자 9자리~11자리를 입력해주세요'
        }
      } else if (txt.match('경동') || txt.match('합동')) {
        if (!(len >= 9 && len <= 16)) {
          result_txt = '숫자 9자리~16자리를 입력해주세요'
        }
      } else if (txt.match('호남') || txt.match('건영') || txt.match(new RegExp('dhl', 'i'))) {
        if (len != 10) {
          result_txt = '숫자 10자리를 입력해주세요'
        }
      } else if (txt.match('한덱스')) {
        if (!(len == 10 || len == 14)) {
          result_txt = '숫자 10자리 또는 14자리를 입력해주세요'
        }
      } else if (txt.match(new RegExp('tnt', 'i'))) {
        if (!(len >= 8 && len <= 9)) {
          result_txt = '숫자 8자리~9자리를 입력해주세요'
        }
      } else {
        result_txt = '택배사 이름을 다시 한번 확인해주세요'
      }

      return result_txt
    },

    async getPrchInfo () {
      const params = {
        // 31199
        ordNum: this.$route.query.ordNum ? this.$route.query.ordNum : this.$route.query.ord_number
      }

      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/pcs/mgmt/public/ord-num', {params})
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {
              console.log(res.data.result)

              const rs = res.data.result

              this.purchaseModel = rs
              this.mdlNm = rs.cate04Nm
              if (!isNotEmpty(this.mdlNm)) {
                this.mdlNm = rs.cate03Nm
              }

              this.decoDirectNm = rs.rcvDecoNm

              if (this.decoDirectNm == '우체국택배' ||
          this.decoDirectNm == 'CJ대한통운' ||
          this.decoDirectNm == '로젠택배' ||
          this.decoDirectNm == '롯데택배' ||
          this.decoDirectNm == '일양택배' ||
          this.decoDirectNm == '한진택배' ||
          this.decoDirectNm == '경동택배' ||
          this.decoDirectNm.includes('CU') ||
          this.decoDirectNm.includes('GS')
              ) {
                // Noting!   Why Not Selected
              } else {
                this.decoDirectNm = 'direct'
              }
            } else {
              Vue.Alert.alert('구매 데이터가 없습니다.')
            }
          } else {
            Vue.Alert.alert('통신오류입니다')
          }
        })
    },

    async saveWybl () { // 운송장저장
      console.log(this.purchaseModel)

      // 택배사
      if (!isNotEmpty(this.decoDirectNm)) {
        alert('택배사를 선택해주세요')
        $('#s_courier').focus()
        return
      } else if (this.decoDirectNm == 'direct') {
        if (!isNotEmpty(this.purchaseModel.rcvDecoNm)) {
          alert('택배사를 입력해주세요')
          $('#d_courier').focus()
          return
        }
      }

      // 운송장번호
      if (!isNotEmpty(this.purchaseModel.rcvWyblNum)) {
        alert('운송장번호를 입력해주세요')
        $('#invoice_number_customer').focus()
        return
      }

      var rtVal = this.invoiceNumberChk(this.purchaseModel.rcvDecoNm, this.purchaseModel.rcvWyblNum.length)

      if (rtVal != 'true') {
        alert(rtVal)
        return false
      }

      const isTrue = await this.$Alert.confirm('배송정보를 저장 하시겠습니까?')
      if (!isTrue) return

      const { data } = await this.$http.post('/api/purchase/pcs/mgmt/public/save-wybl', this.purchaseModel)
      if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
        this.$Alert.alert('배송정보 저장이 완료 되었습니다.').then(() => {
          // this.$router.go()
          $('.return-txt').text('배송정보가 등록 되었습니다.')

          this.isEditable = false
        })
      } else {
        this.$Alert.alert('배송정보 저장 실패하였습니다!')
      }
    },

    onChange: function (event) {
      // console.log(event.target.value);
      if (event.target.value != 'direct') {
        this.purchaseModel.rcvDecoNm = event.target.value
      }
    },

    handleScanCompActive () {
      this.isScannerVisible = !this.isScannerVisible
    },
    handleReadText (decodedText) {
      this.isScannerVisible = false
      this.purchaseModel.rcvWyblNum = decodedText
    }

  }

}
</script>

<style scoped>
.scan_div {
  text-align: center;
  height: 40px;
  line-height: 40px;
}
.scan_btn {
  border: 1px solid tomato;
  border-radius: 15px;
  width: 200px;
  height: 35px;
  background-color: tomato;
  color: #fff;
  font-weight: bolder;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/WyblInfo.vue